import DateHandler from '@/shared/utils/date-format';

export default class UnboundInstance {
  id: string;

  code: string;

  description: string;

  createdDate: string;

  externalId?: string;

  status: string;

  justification: string;

  observation: string;

  inactivatedDate?: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.code = obj.code || '';
    this.description = obj.description || '';
    this.createdDate = DateHandler.timestampToLocal(obj.createdDate) || '';
    this.externalId = obj.externalId || '';
    this.status = obj.status || '';
    this.justification = obj.justification || '';
    this.observation = obj.observation || '';
    this.inactivatedDate = obj.inactivatedDate
      ? DateHandler.timestampToLocal(obj.inactivatedDate) : undefined;
  }

  public static of(obj: any): UnboundInstance {
    return new UnboundInstance(obj);
  }

  public static ofList(obj: any[]): UnboundInstance[] {
    return obj.map(this.of)
  }
}
